var _path, _path2, _g, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 71.2592L49.6386 30C54.186 32.2182 68.0056 37.4533 86.9049 40.6475C105.804 43.8418 134.486 44.4185 146.465 44.3076L130.493 85.8996C122.064 86.2323 99.9482 86.2989 78.9193 83.9032C57.8904 81.5075 40.2111 74.4757 34 71.2592Z",
    fill: "#6299FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_963_740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 30,
    width: 113,
    height: 57
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 71.2592L49.6386 30C54.186 32.2182 68.0056 37.4533 86.9049 40.6475C105.804 43.8418 134.486 44.4185 146.465 44.3076L130.493 85.8996C122.064 86.2323 99.9482 86.2989 78.9193 83.9032C57.8904 81.5075 40.2111 74.4757 34 71.2592Z",
    fill: "#6299FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_963_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2875 90.2246L83.5772 23.6775L50.3037 12.6973L24.0176 78.2462L59.2875 90.2246Z",
    fill: "#3A7EFC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.873 81.9066C99.815 81.9066 91.2304 81.0193 87.5703 80.5757C89.4336 76.0505 99.2161 72.7009 103.874 71.5918H112.525C115.631 72.7009 122.241 75.385 123.838 77.2483C125.436 79.1116 124.948 81.1302 124.504 81.9066H104.873Z",
    fill: "#4586FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.526 71.9249H103.209C103.209 68.7304 104.429 63.717 104.873 61.9425C109.975 60.6115 119.779 58.8813 118.182 62.608C116.585 66.3346 113.635 70.5939 112.526 71.9249Z",
    fill: "#81ADFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.874 79.2447L103.543 71.5918H112.527L104.874 79.2447Z",
    fill: "#3A7EFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.181 62.276H104.539C105.338 58.0171 108.421 56.065 109.863 55.6213C110.085 54.0685 112.059 51.0295 118.181 51.2957C124.304 51.5619 120.732 58.7268 118.181 62.276Z",
    fill: "#3A7EFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoney);
export default __webpack_public_path__ + "static/media/IcMoney.3438a29474eef8e0a98c5b3deb43c567.svg";
export { ForwardRef as ReactComponent };